<h1 mat-dialog-title>{{numContratosSinPagar}} {{'Facturas pendientes de pagar' | translate}}</h1>
<div mat-dialog-content align="center">
</div>
<div mat-dialog-actions align="center">
  <button mat-button class="pure-material-button-contained" [mat-dialog-close] cdkFocusInitial ><i class="fal fa-vote-yea" matTooltip="Ok"></i> {{'Cerrar' | translate}}</button>
</div>